import { Button, Grid, Stack, Box } from '@mui/material';
import { createCustomerPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { AddIcon } from '../../../../../../components/icons/AddIcon.tsx';
import { VyFormSection } from '../../../../../../components/design/layout';
import { CreateCustomerAliases } from './CreateCustomerAliases.tsx';
import type { CreateCustomerMode } from '../../../create-customer-page-types/CreateCustomerModeType.tsx';
import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { NewCustomer, UpdateCustomer } from '@vy/types';
import { withDefault } from '@vy/utils';

export const CustomerAliasesSection: FC<CreateCustomerMode> = ({ mode }) => {
  const { control, setValue } = useFormContext<typeof mode extends 'create' ? NewCustomer : UpdateCustomer>();

  const aliases = useWatch({
    control,
    name: 'aliases',
  });

  const handleAddRow = () => {
    setValue('aliases', [...withDefault(aliases, []), ''], { shouldDirty: true });
  };

  return (
    <VyFormSection title="Aliases">
      <Stack spacing={3}>
        {aliases?.length ? (
          <Grid container spacing={3}>
            <Grid size={10} spacing={2}>
              <CreateCustomerAliases mode={mode} />
            </Grid>
          </Grid>
        ) : null}

        <Box>
          <Button
            {...getSelectorAttribute(createCustomerPageSelectors.advanced.addAlias)}
            startIcon={<AddIcon fill="#000" />}
            onClick={handleAddRow}
            sx={{
              color: '#000',
            }}
          >
            Add alias
          </Button>
        </Box>
      </Stack>
    </VyFormSection>
  );
};
